import React, { useRef } from 'react';
import { AIcon, AIconSize } from '../AIcon';
import { useTracking } from '../../hooks';
import * as Styled from './ACarouselArrow.styles';
import { ACarouselArrowProps, ACarouselArrowDirection } from './ACarouselArrow.types';
import { DEFAULT_NEXT_TEXT, DEFAULT_PREVIOUS_TEXT } from '../../utils/i18nConstants';

const COMPONENT_NAME = 'a-web-ui-kit-ACarouselArrow';
const TEST_ID = 'web-ui-kit-ACarouselArrow';

export const ACarouselArrowDEFAULT_I18N = {
  next: DEFAULT_NEXT_TEXT,
  previous: DEFAULT_PREVIOUS_TEXT,
} as const;

export const ACarouselArrow = React.forwardRef<HTMLButtonElement, ACarouselArrowProps>(
  (
    {
      direction = ACarouselArrowDirection.Left,
      disabled = false,
      transparent = false,
      i18nProperties,
      trackingProperties,
      ...rest
    },
    ref
  ) => {
    const defaultRef = useRef<HTMLButtonElement>(null);
    const elementRef = (ref ?? defaultRef) as React.RefObject<HTMLButtonElement>;

    useTracking({ ref: elementRef, trackingProperties });

    const iconName = direction === ACarouselArrowDirection.Right ? 'icon-arrow-right' : 'icon-arrow-left';
    const ariaLabel =
      direction === ACarouselArrowDirection.Right
        ? i18nProperties?.next ?? ACarouselArrowDEFAULT_I18N.next
        : i18nProperties?.previous ?? ACarouselArrowDEFAULT_I18N.previous;

    return (
      <Styled.ArrowButton
        ref={elementRef}
        disabled={disabled}
        $transparent={transparent}
        aria-label={ariaLabel}
        type="button"
        data-component-name={COMPONENT_NAME}
        data-testid={TEST_ID}
        {...rest}
      >
        <AIcon icon={iconName} size={AIconSize.L} aria-hidden="true" />
      </Styled.ArrowButton>
    );
  }
);

ACarouselArrow.displayName = 'ACarouselArrow';

export { ACarouselArrowDirection, TEST_ID as A_CAROUSEL_ARROW_TEST_ID };
export type { ACarouselArrowProps };
